export default __webpack_public_path__ + "static/media/news-thumb2.a34da991.png";